import { React, useState, useEffect } from 'react';
import GeoGebraP from '../components/GeoGebraP';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import axiosapi from '../api/axiosapi';
import GetProblemInfo from '../components/GetProblemInfo';
import ProblemStatDescription from '../components/ProblemStatDescription';
import useAuth from '../hooks/useAuth';
import UserSolvingStat from '../components/UserSolvingStat';
import 'katex/dist/katex.min.css';
import { InlineMath } from 'react-katex';

const splitContent = (sentence) => {
    const InlineMathRegex = /<InlineMath[^>]*>(.*?)<\/InlineMath>/g;
    const matches = sentence.matchAll(InlineMathRegex);
    let lastIndex = 0;
    const contentArray = [];
  
    for (const match of matches) {
        const InlineMathContent = <InlineMath key={lastIndex} math={match[1]} />;
        const restOfContent = sentence.substring(lastIndex, match.index);
    
        contentArray.push(restOfContent, InlineMathContent);
        lastIndex = match.index + match[0].length;
    }
  
    if (lastIndex < sentence.length) {
        contentArray.push(sentence.substring(lastIndex));
    }
  
    return <div>{contentArray}</div>;
};

const LevelProblem = ()=> {
    const {problemOrderID} = useParams();
    const navigateto = useNavigate();
    const {auth, setAuth} = useAuth();
    const {ListInLevel, levelURL, problemCode, problemOrder} = useLocation().state;
    const location = useLocation();
    const {problem, problemPoemTitle, problemPoem, isPoem, errP} = GetProblemInfo({"problemID": problemCode});
    const {useStat} = UserSolvingStat({"problemCode": problemCode});
    const [isFirst, setIsFirst] = useState(false);
    const [isLast, setIsLast] = useState(false);
    const [prevProblem, setPrevProblem] = useState('');
    const [nextProblem, setNextProblem] = useState('');
    const [prevOrder, setPrevOrder] = useState(0);
    const [nextOrder, setNextOrder] = useState(0);
    const [errFD, setErrFD] = useState(false);
    const [poemFlag,setPoemFlag] = useState(false);
    const [loading, setLoading] = useState(true);
    const [showPoem, setShowPoem] = useState(false);

    useEffect(()=> {
        const getMoveToProblem = () => {
            let problemOrderIDNum = Number(problemOrderID)
            if (problemOrder === 1) {
                setIsFirst(true);
                setPrevProblem(problemCode);
                setPrevOrder(problemOrder);
            } else {
                setIsFirst(false);
                ListInLevel.map(level => {
                    if(level.problemOrder === problemOrderIDNum-1) {
                        setPrevProblem(level.problemCode);
                        setPrevOrder(level.problemOrder);
                    }
                })
            }
            if (problemOrder === ListInLevel.length) {
                setIsLast(true);
                setNextProblem(problemCode);
                setNextOrder(problemOrder);
            } else {
                setIsLast(false);
                ListInLevel.map(level => {
                    if(level.problemOrder === problemOrderIDNum+1) {
                        setNextProblem(level.problemCode);
                        setNextOrder(level.problemOrder);
                    }
                })
            }
        }
        getMoveToProblem();

        const fetchToken = async () => {
            try {
                const response = await axiosapi.post('/refresh-token', {
                            withCredentials: true
                    });
                setAuth(prev => {
                    return { 
                    ...prev, 
                    userRole1: response.data.userRole1,
                    userRole2: response.data.userRole2,
                    accessToken: response.data.access_token 
                    }
                });
            } catch {
                setAuth(prev => {
                    return { 
                    ...prev, 
                    accessToken: null 
                    }
                }); // 로그인 안 된 상태
            } finally {
                setLoading(false);
            }
        }
        !auth?.accessToken && fetchToken();

    },[problemOrderID]);

    useEffect(() => {
        if (problem.problemPoemTitle) {
            setPoemFlag(true)
        } else {
            setPoemFlag(false)
        }
    },[problem.problemPoemTitle])

    console.log("prevProblem", prevProblem);
    console.log("nextProblem", nextProblem);
    console.log("prevOrder", prevOrder);
    console.log("nextOrder", nextOrder);

    if (errP || errFD) {
        return (
            <div className="problem">
                <p>"문제를 다운로드하지 못했습니다. 다시 시도해 주세요."</p>
                <button 
                    className='button'
                    onClick={() => navigateto(-1, {replace: true})}
                >
                    이전화면으로 돌아가기
                </button>
            </div>
        )
    }

    if (problemPoem && problemPoem.length > 1) {
        return(
            <div className="problem" key={problemOrderID}>
                <div className="content-fit">
                    <h5 style={{fontWeight:"bolder", color:"orange" ,marginTop:"22px", marginBottom:"15px"}}>작도와 함께 두뇌 활성화하기</h5>
                    
                    <ProblemStatDescription 
                        topCategoryTitle="작도와 함께 두뇌 활성화하기"
                        problemTitle={problem.problemTitle} 
                        problemDescription={problem.problemDescription}
                        problemId={problem.problemCode}
                        useStat={useStat}
                        problemType={problem.problemType}
                        maxPoint={problem.maxPoint}
                        // problemPoemTitle={problemPoemTitle}
                        // problemPoem={problemPoem}
                    /> 
                    {problem && <GeoGebraP
                        title={problem.problemTitle}
                        // description={problem.description}
                        idIn={problem.problemCode}
                        customToolBarIn={problem.customToolBar}
                        allowStyleBarIn={problem.allowStyleBar}
                        ggbBase64In={problem.problemContent}
                        problemType={problem.problemType}
                        showToolBarHelpIn={problem.showToolBarHelp}
                        enableLabelDragIn={problem.enableLabelDrag}
                        enableShiftDragZoomIn={problem.enableShiftDragZoom}
                    />}
                    <div className='horizontal-flex-container'>
                        {isFirst 
                            ? null 
                            : <button 
                                className='button' 
                                onClick={() => navigateto(`/problem/level/problem/${prevOrder}`, {state:{
                                    "ListInLevel": ListInLevel,
                                    "levelURL": levelURL,
                                    "problemCode": prevProblem,
                                    "problemOrder": prevOrder
                                }})}
                            >
                                이전 문제
                            </button>
                        } 
                        {isLast 
                            ? null 
                            : <button 
                                className='button' 
                                onClick={() => navigateto(`/problem/level/problem/${nextOrder}`, {state:{
                                    "ListInLevel": ListInLevel,
                                    "levelURL": levelURL,
                                    "problemCode": nextProblem,
                                    "problemOrder": nextOrder
                                }})}
                            >
                                다음 문제
                            </button>
                        }
                        {problem.problemFileType === 1 && (problem.problemType === 1 || problem.problemType === 2 || problem.problemType === 4 || problem.problemType === 6 || problem.problemType === 7 || problem.problemType === 701 || problem.problemType === 10 || problem.problemType === 11 || problem.problemType === 12) 
                            ? <button 
                                    className='button'
                                    onClick={
                                        () => auth?.accessToken
                                            ? navigateto(`/problem/level/problem/my/s/list`, {state:{
                                                    "ListInLevel": ListInLevel,
                                                    "levelURL": levelURL,
                                                    "problemCode": problemCode,
                                                    "problemOrder": problemOrder,
                                                    "problem": problem,
                                                    "useStat": useStat,
                                                    "isFirst": isFirst,
                                                    "isLast": isLast,
                                                    "prevProblem": prevProblem,
                                                    "prevOrder": prevOrder,
                                                    "nextProblem": nextProblem,
                                                    "nextOrder": nextOrder
                                                }})
                                            : navigateto("/login", {state:{"from": location}}, {replace: true})
                                    }
                                >
                                    내 풀이보기
                                </button>
                            : null
                        }
                        {<button
                                className='button'
                                onClick={() => setShowPoem(prev => !prev)}
                            >
                                {showPoem ? '시적인 확장 감추기' : ' 시적인 확장 보기'}
                            </button>
                        }
                    </div>
                    <br/>
                    {showPoem && <div style={{marginLeft:"30px"}}>
                        <p><b>{problemPoem && problemPoem.length > 1 && problemPoemTitle !== "NaN" && splitContent(problemPoemTitle)}</b></p>
                        {problemPoem && problemPoem.length > 2 && problemPoem.map(poem => {
                            return (
                                <div>{poem.trim().length>0 ? splitContent(poem) : <br/>}</div>
                                // <div>{poem}<br/></div>
                            )
                        })}
                    </div>}
                </div>
                
            </div>
        );
    } else {
        return(
            <div className="problem" key={problem.problemCode}>
                <div className="content-fit">
                    <h5 style={{fontWeight:"bolder", color:"orange" ,marginTop:"22px", marginBottom:"15px"}}>작도와 함께 두뇌 활성화하기</h5>
                    
                    <ProblemStatDescription 
                        topCategoryTitle="작도와 함께 두뇌 활성화하기"
                        problemTitle={problem.problemTitle} 
                        problemDescription={problem.problemDescription}
                        problemId={problem.problemCode}
                        useStat={useStat}
                        problemType={problem.problemType}
                        maxPoint={problem.maxPoint}
                    /> 
                    {problem && <GeoGebraP
                        title={problem.problemTitle}
                        // description={problem.description}
                        idIn={problem.problemCode}
                        customToolBarIn={problem.customToolBar}
                        allowStyleBarIn={problem.allowStyleBar}
                        ggbBase64In={problem.problemContent}
                        problemType={problem.problemType}
                        showToolBarHelpIn={problem.showToolBarHelp}
                        enableLabelDragIn={problem.enableLabelDrag}
                        enableShiftDragZoomIn={problem.enableShiftDragZoom}
                    />}
                    <div className='horizontal-flex-container'>
                        {isFirst 
                            ? null 
                            : <button 
                                className='button' 
                                onClick={() => navigateto(`/problem/level/problem/${prevOrder}`, {state:{
                                    "ListInLevel": ListInLevel,
                                    "levelURL": levelURL,
                                    "problemCode": prevProblem,
                                    "problemOrder": prevOrder
                                }})}
                            >
                                이전 문제
                            </button>
                        } 
                        {isLast 
                            ? null 
                            : <button 
                                className='button' 
                                onClick={() => navigateto(`/problem/level/problem/${nextOrder}`, {state:{
                                    "ListInLevel": ListInLevel,
                                    "levelURL": levelURL,
                                    "problemCode": nextProblem,
                                    "problemOrder": nextOrder
                                }})}
                            >
                                다음 문제
                            </button>
                        }
                        {problem.problemFileType === 1 && (problem.problemType === 1 || problem.problemType === 2 || problem.problemType === 201 || problem.problemType === 4 || problem.problemType === 6 || problem.problemType === 7 || problem.problemType === 701 || problem.problemType === 10 || problem.problemType === 11 || problem.problemType === 12) 
                            ? <button 
                                    className='button'
                                    onClick={
                                        () => auth?.accessToken
                                            ? navigateto(`/problem/level/problem/my/s/list`, {state:{
                                                    "ListInLevel": ListInLevel,
                                                    "levelURL": levelURL,
                                                    "problemCode": problemCode,
                                                    "problemOrder": problemOrder,
                                                    "problem": problem,
                                                    "useStat": useStat,
                                                    "isFirst": isFirst,
                                                    "isLast": isLast,
                                                    "prevProblem": prevProblem,
                                                    "prevOrder": prevOrder,
                                                    "nextProblem": nextProblem,
                                                    "nextOrder": nextOrder
                                                }})
                                            : navigateto("/login", {state:{"from": location}}, {replace: true})
                                    }
                                >
                                    내 풀이보기
                                </button>
                            : null
                        }
                    </div>
                </div>
                
            </div>
        );
    }
};

export default LevelProblem;
